import P from "@arcgis/core/layers/FeatureLayer";
import h from "@arcgis/core/Graphic";
import S from "@arcgis/core/request";
import { createLogger as pe } from "@origo/logger";
import Ne from "@arcgis/core/geometry/Point";
import qe from "@arcgis/core/geometry/Polygon";
import { z as u } from "zod";
import { jsx as Ue } from "react/jsx-runtime";
import { createContext as xe, useContext as fe } from "react";
import { useQuery as I, useInfiniteQuery as Me, keepPreviousData as me, useQueryClient as g, useMutation as y } from "@tanstack/react-query";
class T extends Error {
  constructor(n, r) {
    super(n, r), this.name = "PlanregisterError";
  }
}
class v extends T {
  constructor(n, r) {
    super(`${n} not found: ${r}`), this.name = "NotFoundError";
  }
}
class w extends T {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "ValidationError";
  }
}
class b extends T {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "NetworkError";
  }
}
class Je extends T {
  constructor(n = "Unauthorized") {
    super(n), this.name = "AuthError";
  }
}
class ge extends T {
  constructor() {
    super("Operation was aborted"), this.name = "AbortedError";
  }
}
const ye = "1";
function M(e) {
  return e.trim().padStart(4, "0");
}
function he(e, n) {
  return `${M(e)}_${n.trim()}`;
}
function J(e) {
  const n = /^(\d{4})\/(\d+)$/.exec(e.trim());
  return n ? { saksaar: Number(n[1]), sakssekvensnr: Number(n[2]) } : { saksaar: void 0, sakssekvensnr: void 0 };
}
function be(e) {
  return e.iBruk ? { arsak: "iBruk" } : e.sperret ? { arsak: "sperret" } : null;
}
const ke = ["3", "6", "7"];
function Q(e) {
  return ke.includes(e);
}
const Ie = ["4", "5", "8"];
function Qe(e) {
  return Ie.includes(e);
}
function je(e) {
  return e.antallPlanforhold > 0 ? { arsak: "planforhold", antall: e.antallPlanforhold } : e.antallDispensasjoner > 0 ? { arsak: "dispensasjoner", antall: e.antallDispensasjoner } : Q(e.planstatus) ? { arsak: "vedtatt" } : null;
}
const Ge = {
  1: "2",
  2: "1",
  3: "4",
  4: "3",
  5: "6",
  6: "5",
  7: "8",
  8: "7",
  9: "10",
  10: "9"
};
function G(e) {
  return Ge[e];
}
function ve(e, n) {
  return e.nasjonalArealplanIdFra === n.nasjonalArealplanIdTil && e.nasjonalArealplanIdTil === n.nasjonalArealplanIdFra && e.forholdtype === G(n.forholdtype);
}
function we(e) {
  return {
    nasjonalArealplanIdFra: e.nasjonalArealplanIdTil,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdFra,
    forholdtype: G(e.forholdtype),
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato,
    begrunnelse: e.begrunnelse
  };
}
function Ae(e, n) {
  return e.nasjonalArealplanIdFra === n ? { motpartPlanId: e.nasjonalArealplanIdTil, forholdtype: e.forholdtype } : { motpartPlanId: e.nasjonalArealplanIdFra, forholdtype: G(e.forholdtype) };
}
const Ve = {
  8: "erstattet",
  10: "delvisErstattet"
};
function He(e, n) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e) {
    if (t.nasjonalArealplanIdFra !== n && t.nasjonalArealplanIdTil !== n)
      continue;
    const { motpartPlanId: s, forholdtype: i } = Ae(t, n), a = Ve[i];
    a && r.get(s) !== "erstattet" && r.set(s, a);
  }
  return [...r].map(([t, s]) => ({ nasjonalArealplanId: t, art: s }));
}
const V = "2";
function Pe(e) {
  return e.planstatus !== void 0 && Q(e.planstatus) && e.dokumenttype === V ? { arsak: "vedtattBestemmelser" } : null;
}
function Fe(e, n) {
  return e.nasjonalArealplanId !== n ? { arsak: "annenPlan" } : e.planbehUid ? { arsak: "alleredeKnyttet" } : null;
}
function Ee(e, n) {
  return e.planbehUid === n;
}
const H = { field: "plannavn", direction: "asc" };
function Y(e) {
  const n = new Date(e);
  return n.setHours(23, 59, 59, 999), n;
}
function N(e, n) {
  const r = n.search?.trim().toLowerCase();
  if (r && !((e.plannavn ?? "").toLowerCase().includes(r) || (e.planId ?? "").toLowerCase().includes(r) || (e.nasjonalArealplanId ?? "").toLowerCase().includes(r)) || n.statuses?.length && !n.statuses.includes(e.planstatus) || n.plantyper?.length && !n.plantyper.includes(e.plantype) || n.lovreferanser?.length && !n.lovreferanser.includes(e.lovreferanse) || n.kommuner?.length && !n.kommuner.includes(e.admomrkode))
    return !1;
  if (n.dateFrom || n.dateTo) {
    const t = e.vedtaksdato ?? e.ikrafttredelsesdato;
    if (!t || n.dateFrom && t.getTime() < n.dateFrom.getTime() || n.dateTo && t.getTime() > Y(n.dateTo).getTime())
      return !1;
  }
  return !0;
}
function De(e, n, r = H) {
  const t = r.direction === "asc" ? 1 : -1;
  let s;
  return r.field === "vedtaksdato" || r.field === "ikrafttredelsesdato" ? s = (e[r.field]?.getTime() ?? 0) - (n[r.field]?.getTime() ?? 0) : s = String(e[r.field] ?? "").localeCompare(String(n[r.field] ?? ""), "nb"), s * t || e.objectId - n.objectId;
}
const Te = [
  "plantype",
  "planstatus",
  "lovreferanse",
  "forslagsstillerType"
];
function Ye(e, n, r) {
  return r == null || r === "" ? "" : e?.[n]?.find((s) => s.code === r)?.label ?? r;
}
function We(e, n) {
  return e?.[n] ?? [];
}
const Be = [
  "planbehandlingtype"
], tt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: ge,
  AuthError: Je,
  CODELIST_FIELDS: Te,
  DEFAULT_AREALPLAN_SORT: H,
  DEFAULT_PLANSTATUS: ye,
  DOKUMENTTYPE_BESTEMMELSER: V,
  IKKE_GJELDENDE_PLANSTATUSER: Ie,
  NetworkError: b,
  NotFoundError: v,
  PLANBEHANDLING_CODELIST_FIELDS: Be,
  PlanregisterError: T,
  VEDTATTE_PLANSTATUSER: ke,
  ValidationError: w,
  compareArealplaner: De,
  deriveNasjonalArealplanId: he,
  domainLabel: Ye,
  domainOptions: We,
  endOfDay: Y,
  erIkkeGjeldende: Qe,
  erVedtatt: Q,
  finnErstattendePlaner: He,
  finnFrakoblingBlokkering: Pe,
  finnIdBlokkering: be,
  finnKoblingBlokkering: Fe,
  finnSlettBlokkering: je,
  kanFjernesFraBehandling: Ee,
  matchesArealplanQuery: N,
  normalizeAdmomrkode: M,
  planforholdSettFra: Ae,
  utledSaksnummerdeler: J
}, Symbol.toStringTag, { value: "Module" }));
function L(e) {
  if (e != null)
    return new Date(e);
}
function _(e) {
  return !!e;
}
function X(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer ?? "",
    saksaar: e.saksaar,
    sakssekvensnr: e.sakssekvensnr,
    forslagsstillerType: e.forslagsstillerType,
    ubehandletKlage: _(e.ubehandletKlage),
    ubehandletInnsigelse: _(e.ubehandletInnsigelse),
    vedtaksdato: L(e.vedtaksdato),
    vedtakEndeligPlanDato: L(e.vedtakEndeligPlanDato),
    ikrafttredelsesdato: L(e.ikrafttredelsesdato),
    kunngjoringsdato: L(e.kunngjoringsdato),
    opprinneligAdmomrKode: e.opprinneligAdmomrKode,
    opprinneligPlanId: e.opprinneligPlanId,
    planbestemmelser: _(e.planbestemmelser)
  };
}
function q(e) {
  return {
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer,
    saksaar: e.saksaar ?? null,
    sakssekvensnr: e.sakssekvensnr ?? null,
    forslagsstillerType: e.forslagsstillerType ?? null,
    ubehandletKlage: e.ubehandletKlage ? 1 : 0,
    ubehandletInnsigelse: e.ubehandletInnsigelse ? 1 : 0,
    vedtaksdato: e.vedtaksdato?.getTime() ?? null,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    ikrafttredelsesdato: e.ikrafttredelsesdato?.getTime() ?? null,
    kunngjoringsdato: e.kunngjoringsdato?.getTime() ?? null,
    opprinneligAdmomrKode: e.opprinneligAdmomrKode ?? null,
    opprinneligPlanId: e.opprinneligPlanId ?? null,
    planbestemmelser: e.planbestemmelser ? 1 : 0
  };
}
function at(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...q(e)
  };
}
function Ze(e) {
  const n = e;
  return n && n.type === "coded-value" && Array.isArray(n.codedValues) ? n.codedValues : null;
}
function $e(e, n) {
  const r = new Map(e.map((s) => [s.name, s])), t = {};
  for (const s of n) {
    const i = Ze(r.get(s)?.domain);
    t[s] = i ? i.map((a) => ({ code: String(a.code), label: a.name })) : [];
  }
  return t;
}
function ze(e) {
  return $e(e, Te);
}
function Xe(e) {
  return e.replace(/'/g, "''");
}
function k(e) {
  return `'${Xe(e)}'`;
}
function $(e, n) {
  return n.length === 0 ? "1=0" : `${e} IN (${n.map(k).join(",")})`;
}
function en(e) {
  return e.replace(/[\\%_]/g, (n) => `\\${n}`);
}
function ee(e) {
  const n = e.toISOString();
  return `TIMESTAMP '${n.slice(0, 10)} ${n.slice(11, 19)}'`;
}
function ne(e, n, r) {
  const t = [`${e} IS NOT NULL`];
  return n && t.push(`${e} >= ${ee(n)}`), r && t.push(`${e} <= ${ee(Y(r))}`), t.join(" AND ");
}
function re(e) {
  const n = [], r = e.search?.trim();
  if (r) {
    const t = `${k(`%${en(r.toUpperCase())}%`)} ESCAPE '\\'`;
    n.push(
      `(UPPER(plannavn) LIKE ${t} OR UPPER(planId) LIKE ${t} OR UPPER(nasjonalArealplanId) LIKE ${t})`
    );
  }
  return e.statuses?.length && n.push($("planstatus", e.statuses)), e.plantyper?.length && n.push($("plantype", e.plantyper)), e.lovreferanser?.length && n.push($("lovreferanse", e.lovreferanser)), e.kommuner?.length && n.push($("admomrkode", e.kommuner)), (e.dateFrom || e.dateTo) && n.push(
    `((${ne("vedtaksdato", e.dateFrom, e.dateTo)}) OR (vedtaksdato IS NULL AND ${ne("ikrafttredelsesdato", e.dateFrom, e.dateTo)}))`
  ), n.length > 0 ? n.join(" AND ") : "1=1";
}
function nn(e = H) {
  const n = e.direction === "asc" ? "ASC" : "DESC";
  return `${e.field} ${n}, OBJECTID ASC`;
}
const rn = pe("planregister:queryTablePaged"), tn = 2e3, an = 1e3;
async function W(e, n, r) {
  const t = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: n.returnGeometry === !0,
    f: "json"
  };
  n.orderByFields && (t.orderByFields = n.orderByFields);
  const s = [];
  let i = 0;
  for (let a = 0; a < an; a++) {
    const o = await K(
      e,
      { ...t, resultOffset: i, resultRecordCount: tn },
      r
    ), l = Se(o);
    if (s.push(...l), o?.exceededTransferLimit !== !0 || l.length === 0)
      break;
    i += l.length;
  }
  return s;
}
async function B(e, n, r) {
  return (await W(e, n, r)).map((s) => s.attributes);
}
async function on(e, n, r, t) {
  const s = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: !1,
    resultOffset: r.offset,
    resultRecordCount: r.limit,
    f: "json"
  };
  n.orderByFields && (s.orderByFields = n.orderByFields);
  const i = await K(e, s, t), a = Se(i).map((o) => o.attributes);
  return { rows: a, hasMore: i?.exceededTransferLimit === !0 && a.length > 0 };
}
async function sn(e, n, r) {
  return (await K(e, { where: n, returnCountOnly: !0, f: "json" }, r))?.count ?? 0;
}
async function ln(e, n, r, t) {
  const s = await K(
    e,
    {
      where: r,
      groupByFieldsForStatistics: n,
      outStatistics: JSON.stringify([
        { statisticType: "count", onStatisticField: "OBJECTID", outStatisticFieldName: "antall" }
      ]),
      f: "json"
    },
    t
  ), i = [];
  for (const a of s?.features ?? []) {
    const o = te(a.attributes, n), l = te(a.attributes, "antall");
    o == null || o === "" || i.push({ value: String(o), count: Number(l ?? 0) });
  }
  return i;
}
function Se(e) {
  return (e?.features ?? []).map(
    (n) => n.geometry ? { attributes: n.attributes, geometry: { ...n.geometry, spatialReference: e?.spatialReference } } : { attributes: n.attributes }
  );
}
function te(e, n) {
  if (n in e)
    return e[n];
  const r = n.toLowerCase(), t = Object.keys(e).find((s) => s.toLowerCase() === r);
  return t ? e[t] : void 0;
}
async function K(e, n, r) {
  try {
    return (await S(`${e}/query`, {
      query: n,
      method: "post",
      responseType: "json",
      signal: r?.signal
    })).data;
  } catch (t) {
    throw r?.signal?.aborted || dn(t) ? new ge() : (rn.error(`Feil ved query mot ${e}:`, t), new b(`Query mot ${e} feilet: ${t?.message ?? t}`, t));
  }
}
function dn(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
const ae = ["planstatus", "plantype", "lovreferanse", "admomrkode"];
function un(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await B(e, { where: a }, o)).map(X);
  return {
    findAll: (a) => i("1=1", a),
    findByNapId: async (a, o) => (await i(`nasjonalArealplanId = ${k(a)}`, o))[0] ?? null,
    search: (a, o) => {
      const l = k(`%${a}%`);
      return i(
        `LOWER(plannavn) LIKE LOWER(${l}) OR nasjonalArealplanId LIKE ${l} OR planId LIKE ${l}`,
        o
      );
    },
    // Lazy loading av planlista (#14578): søk/filter/sortering kjøres i
    // tjenesten, så de gjelder hele registeret og ikke bare lastede sider.
    findPage: async (a, o, l) => {
      const { rows: d, hasMore: f } = await on(
        e,
        { where: re(a), orderByFields: nn(a.sort) },
        o,
        l
      );
      return { items: d.map(X), hasMore: f };
    },
    count: (a, o) => sn(e, re(a), o),
    findByNapIds: (a, o) => a.length === 0 ? Promise.resolve([]) : i($("nasjonalArealplanId", a), o),
    getFacets: async (a) => {
      const o = await Promise.all(ae.map((d) => ln(e, d, "1=1", a))), l = {};
      return ae.forEach((d, f) => {
        l[d] = o[f].sort((m, j) => m.value.localeCompare(j.value, "nb"));
      }), l;
    },
    add: async (a) => s(async () => {
      const o = new h({ attributes: q(a) }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("Arealplan", f);
      return m[0];
    }, "ArealplanRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a.objectId, ...q(a) } }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("Arealplan", a.objectId);
      return d[0];
    }, "ArealplanRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "ArealplanRepository.delete"),
    getDomains: () => s(async () => {
      const a = t();
      return await a.load(), ze(a.fields);
    }, "ArealplanRepository.getDomains")
  };
}
function C(e) {
  if (e != null)
    return new Date(e);
}
function cn(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: C(e.dato),
    fradato: C(e.fradato),
    tildato: C(e.tildato),
    saksnummer: e.saksnummer,
    beskrivelse: e.beskrivelse
  };
}
function U(e) {
  return {
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: e.dato?.getTime() ?? null,
    fradato: e.fradato?.getTime() ?? null,
    tildato: e.tildato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function ot(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...U(e)
  };
}
function pn(e) {
  return $e(e, Be);
}
function fn(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await B(e, { where: a }, o)).map(cn);
  return {
    findForPlan: (a, o) => i(`nasjonalArealplanId = ${k(a)}`, o),
    findByUid: async (a, o) => (await i(`planbehUid = ${k(a)}`, o))[0] ?? null,
    add: async (a) => s(async () => {
      const o = new h({ attributes: U(a) }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("Planbehandling", f);
      return m[0];
    }, "PlanbehandlingRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a.objectId, ...U(a) } }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("Planbehandling", a.objectId);
      return d[0];
    }, "PlanbehandlingRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "PlanbehandlingRepository.delete"),
    getDomains: () => s(async () => {
      const a = t();
      return await a.load(), pn(a.fields);
    }, "PlanbehandlingRepository.getDomains")
  };
}
function mn(e) {
  if (e != null)
    return new Date(e);
}
function gn(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    planbehUid: e.planbehUid,
    dispensasjonId: e.dispensasjonId,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype,
    dokumentstatus: e.dokumentstatus,
    arkivreferanse: e.arkivreferanse,
    arkivnavn: e.arkivnavn,
    dokumentdato: mn(e.dokumentdato),
    saksnummer: e.saksnummer,
    mimetype: e.mimetype,
    referansedokumentfil: e.referansedokumentfil,
    filnavn: e.filnavn,
    beskrivelse: e.beskrivelse
  };
}
function yn(e) {
  return {
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId ?? null,
    planbehUid: e.planbehUid ?? null,
    dispensasjonId: e.dispensasjonId ?? null,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype ?? null,
    dokumentstatus: e.dokumentstatus ?? null,
    arkivreferanse: e.arkivreferanse ?? null,
    arkivnavn: e.arkivnavn ?? null,
    dokumentdato: e.dokumentdato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    mimetype: e.mimetype ?? null,
    referansedokumentfil: e.referansedokumentfil ?? null,
    filnavn: e.filnavn ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
async function hn(e, n, r) {
  const t = new FormData();
  t.append("attachment", r, r.name), t.append("f", "json");
  let s;
  try {
    s = await S(`${e}/${n}/addAttachment`, {
      method: "post",
      body: t,
      responseType: "json"
    });
  } catch (a) {
    throw new b(`Opplasting av vedlegg feilet: ${a?.message ?? a}`, a);
  }
  const i = s.data;
  if (i.error)
    throw new b(`Opplasting av vedlegg feilet: ${i.error.message}`);
  if (!i.addAttachmentResult?.success)
    throw new b("Opplasting av vedlegg feilet");
  return {
    path: `/${n}/attachments/${i.addAttachmentResult.objectId}`,
    filnavn: r.name,
    mimetype: r.type
  };
}
async function bn(e, n) {
  let r;
  try {
    r = await S(`${e}/${n}/attachments`, {
      query: { f: "json" },
      responseType: "json"
    });
  } catch (s) {
    throw new b(`Henting av vedlegg feilet: ${s?.message ?? s}`, s);
  }
  const t = r.data;
  if (t.error)
    throw new b(`Henting av vedlegg feilet: ${t.error.message}`);
  return (t.attachmentInfos ?? []).map((s) => s.id);
}
async function kn(e, n) {
  const r = await bn(e, n);
  if (r.length === 0)
    return;
  let t;
  try {
    t = await S(`${e}/${n}/deleteAttachments`, {
      query: { attachmentIds: r.join(","), f: "json" },
      method: "post",
      responseType: "json"
    });
  } catch (a) {
    throw new b(`Sletting av vedlegg feilet: ${a?.message ?? a}`, a);
  }
  const s = t.data;
  if (s.error)
    throw new b(`Sletting av vedlegg feilet: ${s.error.message}`);
  const i = s.deleteAttachmentResults?.find((a) => !a.success);
  if (i)
    throw new b(`Sletting av vedlegg feilet: ${i.error?.description ?? "ukjent feil"}`);
}
async function In(e, n) {
  try {
    const r = n.startsWith("/") ? `${e}${n}` : n, t = await S(r, { responseType: "blob" });
    return URL.createObjectURL(t.data);
  } catch {
    return null;
  }
}
const jn = pe("planregister:plandokumentRepository");
function vn(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await B(e, { where: a }, o)).map(gn);
  return {
    findForPlan: (a, o) => i(`nasjonalArealplanId = ${k(a)}`, o),
    findForBehandling: (a, o) => i(`planbehUid = ${k(a)}`, o),
    findForDispensasjon: (a, o) => i(`dispensasjonId = ${k(a)}`, o),
    add: async (a, o) => s(async () => {
      const l = new h({ attributes: yn(a) }), f = (await t().applyEdits({ addFeatures: [l] })).addFeatureResults[0];
      if (f.error)
        throw new Error(f.error.message);
      const m = f.objectId;
      if (o) {
        const E = await hn(e, m, o), R = new h({
          attributes: {
            OBJECTID: m,
            referansedokumentfil: E.path,
            filnavn: E.filnavn,
            mimetype: E.mimetype
          }
        });
        await t().applyEdits({ updateFeatures: [R] });
      }
      const j = await i(`OBJECTID = ${m}`);
      if (!j[0])
        throw new v("Plandokument", m);
      return j[0];
    }, "PlandokumentRepository.add"),
    settBehandling: async (a, o) => s(async () => {
      const l = a.map(
        (m) => new h({ attributes: { OBJECTID: m, planbehUid: o } })
      ), f = (await t().applyEdits(
        { updateFeatures: l },
        { rollbackOnFailureEnabled: !0 }
      )).updateFeatureResults.find((m) => m.error);
      if (f)
        throw new Error(f.error.message);
    }, "PlandokumentRepository.settBehandling"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
      try {
        await kn(e, a);
      } catch (l) {
        jn.warn(`Opprydding av vedlegg for plandokument ${a} feilet etter sletting`, l);
      }
    }, "PlandokumentRepository.delete"),
    fetchAttachmentBlobUrl: (a) => In(e, a)
  };
}
function wn(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle,
    organisasjon: e.organisasjon,
    kontaktperson: e.kontaktperson
  };
}
function x(e) {
  return {
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle ?? null,
    organisasjon: e.organisasjon ?? null,
    kontaktperson: e.kontaktperson ?? null
  };
}
function st(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...x(e)
  };
}
function An(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await B(e, { where: a }, o)).map(wn);
  return {
    findForBehandling: (a, o) => i(`planbehUid = ${k(a)}`, o),
    add: async (a) => s(async () => {
      const o = new h({ attributes: x(a) }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("Aktor", f);
      return m[0];
    }, "AktorRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a.objectId, ...x(a) } }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("Aktor", a.objectId);
      return d[0];
    }, "AktorRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "AktorRepository.delete")
  };
}
function Pn(e) {
  if (e != null)
    return new Date(e);
}
function Fn(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: Pn(e.vedtakEndeligPlanDato),
    begrunnelse: e.begrunnelse
  };
}
function oe(e) {
  return {
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    begrunnelse: e.begrunnelse ?? null
  };
}
function En(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await B(e, { where: a }, o)).map(Fn);
  return {
    findForPlan: (a, o) => i(`nasjonalArealplanIdFra = ${k(a)} OR nasjonalArealplanIdTil = ${k(a)}`, o),
    add: async (a) => s(async () => {
      const o = new h({ attributes: oe(a) }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("Planforhold", f);
      return m[0];
    }, "PlanforholdRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({
        attributes: { OBJECTID: a.objectId, ...oe(a) }
      }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("Planforhold", a.objectId);
      return d[0];
    }, "PlanforholdRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "PlanforholdRepository.delete")
  };
}
function se(e) {
  if (e != null)
    return new Date(e);
}
function A(e) {
  return e ?? void 0;
}
function Dn(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: A(e.kommunenummer),
    planidentifikasjon: A(e.planidentifikasjon),
    dispensasjonType: A(e.dispensasjonType),
    dispensasjonFra: A(e.dispensasjonFra),
    begrunnelse: A(e.begrunnelse),
    vedtaksdato: new Date(e.vedtaksdato),
    vertikalnivaa: A(e.vertikalnivaa),
    beskrivelse: A(e.beskrivelse),
    innvilgetDispensasjon: !!e.innvilgetDispensasjon,
    varigDispensasjon: !!e.varigDispensasjon,
    varighetFra: se(e.varighetFra),
    varighetTil: se(e.varighetTil),
    sakssekvensnummer: A(e.saksnummer__sakssekvensnummer),
    saksaar: A(e.saksnummer__saksaar),
    geometry: n
  };
}
function le(e) {
  return {
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer ?? null,
    planidentifikasjon: e.planidentifikasjon ?? null,
    dispensasjonType: e.dispensasjonType ?? null,
    dispensasjonFra: e.dispensasjonFra ?? null,
    begrunnelse: e.begrunnelse ?? null,
    vedtaksdato: e.vedtaksdato.getTime(),
    vertikalnivaa: e.vertikalnivaa ?? null,
    beskrivelse: e.beskrivelse ?? null,
    innvilgetDispensasjon: e.innvilgetDispensasjon ? 1 : 0,
    varigDispensasjon: e.varigDispensasjon ? 1 : 0,
    varighetFra: e.varighetFra?.getTime() ?? null,
    varighetTil: e.varighetTil?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null
  };
}
function Tn(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await W(e, { where: a, returnGeometry: !0 }, o)).map(
    (d) => Dn(d.attributes, d.geometry ? Ne.fromJSON(d.geometry) : void 0)
  );
  return {
    findForPlan: (a, o) => i(`nasjonalArealplanId = ${k(a)}`, o),
    findByDispensasjonId: async (a, o) => (await i(`dispensasjonId = ${k(a)}`, o))[0] ?? null,
    add: async (a) => s(async () => {
      const o = new h({
        attributes: le(a),
        geometry: a.geometry
      }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("Dispensasjon", f);
      return m[0];
    }, "DispensasjonRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({
        attributes: { OBJECTID: a.objectId, ...le(a) },
        geometry: a.geometry
      }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("Dispensasjon", a.objectId);
      return d[0];
    }, "DispensasjonRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "DispensasjonRepository.delete")
  };
}
function ie(e) {
  if (e != null)
    return new Date(e);
}
function Bn(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn,
    avgjdato: ie(e.avgjdato),
    gyldigtildato: ie(e.gyldigtildato),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    informasjon: e.informasjon,
    geometry: n
  };
}
function de(e) {
  return {
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer ?? null,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn ?? null,
    avgjdato: e.avgjdato?.getTime() ?? null,
    gyldigtildato: e.gyldigtildato?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null,
    informasjon: e.informasjon ?? null
  };
}
function $n(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (a, o) => {
    try {
      return await a();
    } catch (l) {
      throw l instanceof Error && l.name === "AbortError" ? l : new b(`${o} feilet: ${l?.message ?? l}`, l);
    }
  }, i = async (a, o) => (await W(e, { where: a, returnGeometry: !0 }, o)).map(
    (d) => Bn(d.attributes, d.geometry ? qe.fromJSON(d.geometry) : void 0)
  );
  return {
    findForKommune: (a, o) => i(`kommunenummer = ${k(a)}`, o),
    findByForbudId: async (a, o) => (await i(`forbudId = ${k(a)}`, o))[0] ?? null,
    add: async (a) => s(async () => {
      const o = new h({
        attributes: de(a),
        geometry: a.geometry
      }), d = (await t().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (d.error)
        throw new Error(d.error.message);
      const f = d.objectId, m = await i(`OBJECTID = ${f}`);
      if (!m[0])
        throw new v("MidlertidigForbud", f);
      return m[0];
    }, "MidlertidigForbudRepository.add"),
    update: async (a) => s(async () => {
      const o = new h({
        attributes: { OBJECTID: a.objectId, ...de(a) },
        geometry: a.geometry
      }), l = await t().applyEdits({ updateFeatures: [o] });
      if (l.updateFeatureResults[0].error)
        throw new Error(l.updateFeatureResults[0].error.message);
      const d = await i(`OBJECTID = ${a.objectId}`);
      if (!d[0])
        throw new v("MidlertidigForbud", a.objectId);
      return d[0];
    }, "MidlertidigForbudRepository.update"),
    delete: async (a) => s(async () => {
      const o = new h({ attributes: { OBJECTID: a } });
      await t().applyEdits({ deleteFeatures: [o] });
    }, "MidlertidigForbudRepository.delete")
  };
}
function Sn(e, n) {
  let r = null;
  const t = () => (r ?? (r = new P({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), s = async (i, a) => (await B(e, { where: `nasjonalArealplanId = ${k(i)}` }, a)).length > 0;
  return {
    erSperret: s,
    sperr: async (i) => {
      let a;
      try {
        const d = new h({ attributes: { ...i } });
        a = (await t().applyEdits({ addFeatures: [d] })).addFeatureResults[0].error ?? void 0;
      } catch (d) {
        if (d instanceof Error && d.name === "AbortError")
          throw d;
        a = d ?? new Error("Ukjent feil");
      }
      if (a === void 0)
        return !0;
      let o = !1;
      try {
        o = await s(i.nasjonalArealplanId);
      } catch {
      }
      if (o)
        return !1;
      const l = a?.message ?? String(a);
      throw new b(`ArealplanIdSperrelisteRepository.sperr feilet: ${l}`, a);
    }
  };
}
const Rn = 0, Ln = 1, On = 2, Kn = 3, _n = 4, Cn = 5, Nn = 6, qn = 7;
function lt(e) {
  const n = e.serviceUrl.replace(/\/$/, ""), r = (s) => `${n}/${s}`, { getToken: t } = e;
  return {
    arealplaner: un(r(On), t),
    behandlinger: fn(r(Kn), t),
    dokumenter: vn(r(_n), t),
    aktorer: An(r(Cn), t),
    planforhold: En(r(Nn), t),
    dispensasjoner: Tn(r(Rn), t),
    midlertidigeForbud: $n(r(Ln), t),
    sperreliste: Sn(r(qn), t)
  };
}
const c = {
  all: ["planregister"],
  arealplaner: {
    all: ["planregister", "arealplaner"],
    searchAll: ["planregister", "arealplaner", "search"],
    search: (e) => ["planregister", "arealplaner", "search", e],
    pagesAll: ["planregister", "arealplaner", "pages"],
    pages: (e, n) => ["planregister", "arealplaner", "pages", e, n],
    count: (e) => ["planregister", "arealplaner", "count", e],
    byNapIds: (e) => ["planregister", "arealplaner", "byNapIds", e],
    facets: ["planregister", "arealplaner", "facets"],
    byNapId: (e) => ["planregister", "arealplaner", e],
    slettegrunnlag: (e) => ["planregister", "arealplaner", e, "slettegrunnlag"],
    domains: ["planregister", "arealplaner", "domains"]
  },
  behandlinger: {
    all: ["planregister", "behandlinger"],
    forPlan: (e) => ["planregister", "behandlinger", e],
    byUid: (e) => ["planregister", "behandlinger", "uid", e],
    domains: ["planregister", "behandlinger", "domains"]
  },
  dokumenter: {
    all: ["planregister", "dokumenter"],
    forPlan: (e) => ["planregister", "dokumenter", "plan", e],
    forBehandling: (e) => ["planregister", "dokumenter", "behandling", e],
    forDispensasjon: (e) => ["planregister", "dokumenter", "dispensasjon", e]
  },
  aktorer: {
    all: ["planregister", "aktorer"],
    forBehandling: (e) => ["planregister", "aktorer", e]
  },
  planforhold: {
    all: ["planregister", "planforhold"],
    forPlan: (e) => ["planregister", "planforhold", e]
  },
  dispensasjoner: {
    all: ["planregister", "dispensasjoner"],
    forPlan: (e) => ["planregister", "dispensasjoner", e],
    byId: (e) => ["planregister", "dispensasjoner", "id", e]
  },
  midlertidigeForbud: {
    all: ["planregister", "midlertidigeForbud"],
    forKommune: (e) => ["planregister", "midlertidigeForbud", e],
    byId: (e) => ["planregister", "midlertidigeForbud", "id", e]
  }
}, Un = ["10", "11", "13", "20", "21", "34", "35", "30", "31"], Re = ["1", "2", "3", "4", "5", "6", "7", "8"], xn = ["PBL2008", "PBL1985", "BL1965"], Mn = ["1", "2", "3", "4", "9"], O = (e) => ({ errorMap: () => ({ message: e }) }), Le = u.object({
  plannavn: u.string().trim().min(1, "Plannavn er påkrevd").max(250, "Plannavn er for langt"),
  plantype: u.enum(Un, O("Velg en gyldig plantype")),
  planstatus: u.enum(Re, O("Velg en gyldig planstatus")).optional(),
  lovreferanse: u.enum(xn, O("Velg en gyldig lovreferanse")),
  saksnummer: u.string().trim().min(1, "Saksnummer er påkrevd"),
  admomrkode: u.string().trim().min(1, "Kommunenummer er påkrevd").regex(/^\d{1,4}$/, "Kommunenummer må være inntil 4 siffer"),
  planId: u.string().trim().min(1, "PlanID er påkrevd"),
  saksaar: u.number().int().optional(),
  sakssekvensnr: u.number().int().optional(),
  forslagsstillerType: u.enum(Mn, O("Velg en gyldig forslagsstillertype")).optional(),
  ubehandletKlage: u.boolean().optional(),
  ubehandletInnsigelse: u.boolean().optional(),
  vedtaksdato: u.date().optional(),
  vedtakEndeligPlanDato: u.date().optional(),
  ikrafttredelsesdato: u.date().optional(),
  kunngjoringsdato: u.date().optional(),
  opprinneligAdmomrKode: u.string().trim().optional(),
  opprinneligPlanId: u.string().trim().optional(),
  planbestemmelser: u.boolean().optional()
}), Jn = (e) => ({ errorMap: () => ({ message: e }) }), Oe = Le.pick({
  plannavn: !0,
  plantype: !0,
  lovreferanse: !0,
  saksnummer: !0,
  forslagsstillerType: !0,
  vedtaksdato: !0,
  vedtakEndeligPlanDato: !0,
  ikrafttredelsesdato: !0,
  kunngjoringsdato: !0
}).extend({
  planstatus: u.enum(Re, Jn("Velg en gyldig planstatus")),
  ubehandletKlage: u.boolean(),
  ubehandletInnsigelse: u.boolean(),
  planbestemmelser: u.boolean()
}), Qn = u.object({
  planbehUid: u.string().trim().min(1, "planbehUid er påkrevd"),
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  navn: u.string().trim().min(1, "Navn er påkrevd").max(250, "Navn er for langt"),
  planbehandlingtype: u.string().trim().min(1, "Velg behandlingstype"),
  dato: u.date({ required_error: "Dato er påkrevd", invalid_type_error: "Ugyldig dato" }),
  fradato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  tildato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  saksnummer: u.string().trim().max(50, "Saksnummer er for langt").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelsen er for lang").optional()
}).superRefine((e, n) => {
  e.fradato && e.tildato && e.tildato < e.fradato && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["tildato"],
    message: "Til-dato kan ikke være før fra-dato"
  });
}), Gn = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  tittel: u.string().trim().min(1, "Tittel er påkrevd").max(250, "Tittel er for lang"),
  dokumenttype: u.string().trim().optional()
}), Vn = [
  "100",
  "110",
  "111",
  "120",
  "130",
  "140",
  "141",
  "142",
  "143",
  "150",
  "160",
  "161",
  "162",
  "163",
  "165",
  "170",
  "171",
  "172",
  "173",
  "174",
  "200",
  "300",
  "400",
  "500"
], Hn = ["ARB", "PLAN", "TEK", "FORU", "JORD", "KOM", "PBL", "VEG"], ue = (e) => ({ errorMap: () => ({ message: e }) }), it = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  dispensasjonType: u.enum(Vn, ue("Velg en gyldig dispensasjonstype")).optional(),
  dispensasjonFra: u.enum(Hn, ue("Velg et gyldig lovverk")).optional(),
  vedtaksdato: u.date({ required_error: "Vedtaksdato er påkrevd", invalid_type_error: "Vedtaksdato er påkrevd" }),
  innvilgetDispensasjon: u.boolean(),
  varigDispensasjon: u.boolean(),
  varighetFra: u.date().optional(),
  varighetTil: u.date().optional(),
  saksaar: u.number().int().optional(),
  sakssekvensnummer: u.number().int().optional(),
  begrunnelse: u.string().trim().max(2e3, "Begrunnelse er for lang").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelse er for lang").optional()
}).superRefine((e, n) => {
  !e.varigDispensasjon && e.varighetFra === void 0 && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["varighetFra"],
    message: "Varighet fra er påkrevd når dispensasjonen ikke er varig"
  }), !e.varigDispensasjon && e.varighetTil === void 0 && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["varighetTil"],
    message: "Varighet til er påkrevd når dispensasjonen ikke er varig"
  });
}).refine(
  (e) => !e.varighetFra || !e.varighetTil || e.varighetTil > e.varighetFra,
  { message: "Varighet til må være etter varighet fra", path: ["varighetTil"] }
);
async function Yn(e, n) {
  return e.arealplaner.findAll(n);
}
async function Wn(e, n, r) {
  return e.arealplaner.findByNapId(n, r);
}
async function Zn(e, n, r) {
  return e.arealplaner.search(n, r);
}
async function zn(e, n, r, t) {
  return e.arealplaner.findPage(n, r, t);
}
async function Xn(e, n, r) {
  return e.arealplaner.count(n, r);
}
async function er(e, n, r) {
  return e.arealplaner.findByNapIds(n, r);
}
async function nr(e, n) {
  return e.arealplaner.getFacets(n);
}
async function rr(e, n, r) {
  const t = Le.safeParse(n);
  if (!t.success)
    throw Ke(t.error);
  const s = t.data, i = M(s.admomrkode), a = he(i, s.planId), o = s.planId.trim(), [l, d] = await Promise.all([
    e.arealplaner.findByNapId(a, r),
    e.sperreliste.erSperret(a, r)
  ]), f = be({ iBruk: l !== null, sperret: d });
  if (f)
    throw new w(ce(f, o, i, a));
  if (!await e.sperreliste.sperr({ nasjonalArealplanId: a, admomrkode: i, planId: o }))
    throw new w(ce({ arsak: "sperret" }, o, i, a));
  const j = J(s.saksnummer), E = {
    ...s,
    saksaar: s.saksaar ?? j.saksaar,
    sakssekvensnr: s.sakssekvensnr ?? j.sakssekvensnr,
    admomrkode: i,
    planId: o,
    nasjonalArealplanId: a,
    planstatus: s.planstatus ?? ye,
    ubehandletKlage: s.ubehandletKlage ?? !1,
    ubehandletInnsigelse: s.ubehandletInnsigelse ?? !1,
    planbestemmelser: s.planbestemmelser ?? !1
  };
  return e.arealplaner.add(E);
}
function ce(e, n, r, t) {
  switch (e.arsak) {
    case "iBruk":
      return `Plan-ID «${n}» finnes allerede i kommune ${r} (${t}).`;
    case "sperret":
      return `Plan-ID «${n}» er brukt tidligere i kommune ${r} (${t}) og kan ikke gjenbrukes.`;
  }
}
async function tr(e, n) {
  return e.arealplaner.getDomains(n);
}
const ar = Object.keys(Oe.shape);
function or(e, n) {
  return e instanceof Date || n instanceof Date ? e instanceof Date && n instanceof Date && e.getTime() === n.getTime() : e === n;
}
async function sr(e, n, r) {
  const t = await e.arealplaner.findByNapId(n.nasjonalArealplanId, r);
  if (!t)
    throw new v("Arealplan", n.nasjonalArealplanId);
  const s = ar.filter((l) => !or(n[l], t[l])), i = Object.fromEntries(s.map((l) => [l, !0])), a = Oe.pick(i).safeParse(n);
  if (!a.success)
    throw Ke(a.error);
  const o = a.data;
  return e.arealplaner.update({
    ...n,
    ...o,
    ...o.saksnummer !== void 0 ? J(o.saksnummer) : {}
  });
}
function Ke(e) {
  const { message: n, path: r } = e.issues[0], t = r.join(".");
  return new w(t ? `${t}: ${n}` : n, e);
}
async function _e(e, n, r) {
  const t = n.nasjonalArealplanId, [s, i, a, o] = await Promise.all([
    e.planforhold.findForPlan(t, r),
    e.dispensasjoner.findForPlan(t, r),
    e.behandlinger.findForPlan(t, r),
    e.dokumenter.findForPlan(t, r)
  ]), l = await Promise.all(a.map((j) => Promise.all([
    e.aktorer.findForBehandling(j.planbehUid, r),
    e.dokumenter.findForBehandling(j.planbehUid, r)
  ]))), d = new Map(o.map((j) => [j.objectId, j])), f = [];
  for (const [j, E] of l) {
    f.push(...j);
    for (const R of E)
      d.set(R.objectId, R);
  }
  return { blokkering: je({
    planstatus: n.planstatus,
    antallPlanforhold: s.length,
    antallDispensasjoner: i.length
  }), behandlinger: a, dokumenter: [...d.values()], aktorer: f };
}
async function lr(e, n) {
  const r = await _e(e, n);
  if (r.blokkering)
    throw new w(ir(r.blokkering));
  await e.sperreliste.sperr({
    nasjonalArealplanId: n.nasjonalArealplanId,
    admomrkode: n.admomrkode,
    planId: n.planId
  });
  for (const t of r.dokumenter)
    await e.dokumenter.delete(t.objectId);
  for (const t of r.aktorer)
    await e.aktorer.delete(t.objectId);
  for (const t of r.behandlinger)
    await e.behandlinger.delete(t.objectId);
  await e.arealplaner.delete(n.objectId);
}
function ir(e) {
  switch (e.arsak) {
    case "planforhold":
      return `Planen inngår i ${e.antall} planforhold som må fjernes før planen kan slettes.`;
    case "dispensasjoner":
      return `Planen har ${e.antall} dispensasjoner som må fjernes før planen kan slettes.`;
    case "vedtatt":
      return "En vedtatt plan kan ikke slettes. Sett status til Opphevet først.";
  }
}
async function dr(e, n) {
  return e.behandlinger.getDomains(n);
}
async function ur(e, n, r) {
  return e.behandlinger.findForPlan(n, r);
}
async function dt(e, n, r) {
  return e.behandlinger.findByUid(n, r);
}
function Ce(e) {
  const n = Qn.safeParse(e);
  if (!n.success) {
    const { message: t, path: s } = n.error.issues[0], i = s.join(".");
    throw new w(i ? `${i}: ${t}` : t, n.error);
  }
  const r = n.data;
  return {
    ...r,
    saksnummer: r.saksnummer || void 0,
    beskrivelse: r.beskrivelse || void 0
  };
}
async function cr(e, n) {
  return e.behandlinger.add(Ce(n));
}
async function pr(e, n) {
  const { objectId: r, globalId: t, ...s } = n;
  return e.behandlinger.update({ objectId: r, globalId: t, ...Ce(s) });
}
async function fr(e, n) {
  return e.behandlinger.delete(n);
}
function mr(e) {
  const n = Gn.safeParse(e);
  if (!n.success) {
    const { message: r, path: t } = n.error.issues[0], s = t.join(".");
    throw new w(s ? `${s}: ${r}` : r, n.error);
  }
  return e;
}
async function gr(e, n, r) {
  return e.dokumenter.findForPlan(n, r);
}
async function yr(e, n, r) {
  return e.dokumenter.findForBehandling(n, r);
}
async function hr(e, n, r) {
  return e.dokumenter.findForDispensasjon(n, r);
}
async function br(e, n, r) {
  return e.dokumenter.add(mr(n), r);
}
async function kr(e, n, r, t) {
  if (n.length === 0)
    throw new w("Ingen dokumenter er valgt.");
  const s = new Map((await e.dokumenter.findForPlan(t)).map((i) => [i.objectId, i]));
  for (const i of n) {
    const a = Fe(s.get(i.objectId) ?? {}, t);
    if (a)
      throw new w(wr(a, i.tittel));
  }
  return e.dokumenter.settBehandling(
    n.map((i) => i.objectId),
    r
  );
}
async function Ir(e, n, r) {
  const t = (await e.dokumenter.findForBehandling(r)).find(
    (s) => s.objectId === n.objectId
  );
  if (!t || !Ee(t, r))
    throw new w(`«${n.tittel}» er ikke knyttet til denne behandlingen.`);
  return e.dokumenter.settBehandling([n.objectId], null);
}
async function jr(e, n) {
  return e.dokumenter.fetchAttachmentBlobUrl(n);
}
async function vr(e, n, r) {
  if (n.dokumenttype === V) {
    const t = n.nasjonalArealplanId ?? r, s = t ? await e.arealplaner.findByNapId(t) : null;
    if (!s)
      throw new w(
        "Fant ikke planen bestemmelsene tilhører, så det kan ikke avgjøres om de kan fjernes."
      );
    const i = Pe({
      planstatus: s.planstatus,
      dokumenttype: n.dokumenttype
    });
    if (i)
      throw new w(Ar(i));
  }
  return e.dokumenter.delete(n.objectId);
}
function wr(e, n) {
  switch (e.arsak) {
    case "annenPlan":
      return `«${n}» hører ikke til denne planen.`;
    case "alleredeKnyttet":
      return `«${n}» er allerede knyttet til en behandling.`;
  }
}
function Ar(e) {
  switch (e.arsak) {
    case "vedtattBestemmelser":
      return "Bestemmelser på en vedtatt plan kan ikke fjernes fra planregisteret.";
  }
}
async function Pr(e, n, r) {
  return e.aktorer.findForBehandling(n, r);
}
async function Fr(e, n) {
  return e.aktorer.add(n);
}
async function Er(e, n) {
  return e.aktorer.update(n);
}
async function Dr(e, n) {
  return e.aktorer.delete(n);
}
async function Tr(e, n, r) {
  return e.planforhold.findForPlan(n, r);
}
async function Br(e, n) {
  return e.planforhold.add(n);
}
async function $r(e, n) {
  const r = await e.planforhold.add(n);
  try {
    const t = await e.planforhold.add({ ...we(n), relasjonId: crypto.randomUUID() });
    return [r, t];
  } catch (t) {
    throw await e.planforhold.delete(r.objectId), t;
  }
}
async function Sr(e, n, r) {
  const s = (await e.planforhold.findForPlan(n.nasjonalArealplanIdTil)).find((l) => l.objectId !== n.objectId && ve(l, n)), i = await e.planforhold.update({ ...n, ...r, relasjonId: n.relasjonId });
  if (!s)
    return i;
  const a = we(r);
  let o;
  try {
    return s.nasjonalArealplanIdFra === a.nasjonalArealplanIdFra && s.nasjonalArealplanIdTil === a.nasjonalArealplanIdTil ? await e.planforhold.update({ ...s, ...a }) : (o = await e.planforhold.add({ ...a, relasjonId: crypto.randomUUID() }), await e.planforhold.delete(s.objectId)), i;
  } catch (l) {
    throw o && await e.planforhold.delete(o.objectId).catch(() => {
    }), await e.planforhold.update(n).catch(() => {
    }), l;
  }
}
async function Rr(e, n) {
  const t = (await e.planforhold.findForPlan(n.nasjonalArealplanIdTil)).find((s) => s.objectId !== n.objectId && ve(s, n));
  if (await e.planforhold.delete(n.objectId), !!t)
    try {
      await e.planforhold.delete(t.objectId);
    } catch (s) {
      const { objectId: i, globalId: a, ...o } = n;
      throw await e.planforhold.add(o).catch(() => {
      }), s;
    }
}
async function Lr(e, n) {
  return e.planforhold.delete(n);
}
async function Or(e, n, r) {
  return e.dispensasjoner.findForPlan(n, r);
}
async function ut(e, n, r) {
  return e.dispensasjoner.findByDispensasjonId(n, r);
}
async function Kr(e, n) {
  return e.dispensasjoner.add(n);
}
async function _r(e, n) {
  return e.dispensasjoner.update(n);
}
async function Cr(e, n) {
  return e.dispensasjoner.delete(n);
}
async function Nr(e, n, r) {
  return e.midlertidigeForbud.findForKommune(n, r);
}
async function ct(e, n, r) {
  return e.midlertidigeForbud.findByForbudId(n, r);
}
async function qr(e, n) {
  return e.midlertidigeForbud.add(n);
}
async function Ur(e, n) {
  return e.midlertidigeForbud.update(n);
}
async function xr(e, n) {
  return e.midlertidigeForbud.delete(n);
}
const Z = xe(null);
function pt({ client: e, children: n }) {
  return /* @__PURE__ */ Ue(Z.Provider, { value: e, children: n });
}
function p() {
  const e = fe(Z);
  if (!e)
    throw new Error("usePlanregisterClient must be used inside <PlanregisterClientProvider>");
  return e;
}
function ft() {
  return fe(Z);
}
const Mr = 50;
function z(e) {
  e.invalidateQueries({
    queryKey: c.arealplaner.all,
    predicate: (n) => n.queryKey[2] !== c.arealplaner.pagesAll[2]
  }), e.resetQueries({ queryKey: c.arealplaner.pagesAll });
}
function mt() {
  const e = p();
  return I({
    queryKey: c.arealplaner.all,
    queryFn: ({ signal: n }) => Yn(e, { signal: n })
  });
}
function gt(e) {
  const n = p();
  return I({
    queryKey: c.arealplaner.search(e),
    queryFn: ({ signal: r }) => Zn(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function yt(e, n = Mr) {
  const r = p();
  return Me({
    queryKey: c.arealplaner.pages(e, n),
    queryFn: ({ pageParam: t, signal: s }) => zn(r, e, { offset: t, limit: n }, { signal: s }),
    initialPageParam: 0,
    // Neste offset = antall rader hentet så langt (serveren kan klampe sidestørrelsen).
    getNextPageParam: (t, s) => t.hasMore ? s.reduce((i, a) => i + a.items.length, 0) : void 0,
    placeholderData: me,
    // Refetch av en infinite query henter alle lastede sider sekvensielt —
    // ikke gjør det ved vindusfokus. Endringer nullstiller lista i stedet
    // (se invalidateArealplaner).
    refetchOnWindowFocus: !1
  });
}
function ht(e) {
  const n = p();
  return I({
    queryKey: c.arealplaner.count(e),
    queryFn: ({ signal: r }) => Xn(n, e, { signal: r }),
    placeholderData: me
  });
}
function bt(e) {
  const n = p();
  return I({
    queryKey: c.arealplaner.byNapIds(e),
    queryFn: ({ signal: r }) => er(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function kt() {
  const e = p();
  return I({
    queryKey: c.arealplaner.facets,
    queryFn: ({ signal: n }) => nr(e, { signal: n })
  });
}
function It(e) {
  const n = p();
  return I({
    queryKey: c.arealplaner.byNapId(e ?? ""),
    queryFn: ({ signal: r }) => Wn(n, e, { signal: r }),
    enabled: !!e
  });
}
function jt() {
  const e = p();
  return I({
    queryKey: c.arealplaner.domains,
    queryFn: ({ signal: n }) => tr(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function vt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => rr(e, r),
    onSuccess: () => z(n)
  });
}
function wt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => sr(e, r),
    onSuccess: (r) => {
      z(n), n.invalidateQueries({ queryKey: c.arealplaner.byNapId(r.nasjonalArealplanId) });
    }
  });
}
function At(e, n = !0) {
  const r = p();
  return I({
    queryKey: c.arealplaner.slettegrunnlag(e?.nasjonalArealplanId ?? ""),
    queryFn: ({ signal: t }) => _e(r, e, { signal: t }),
    enabled: n && !!e,
    staleTime: 0
  });
}
function Pt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => lr(e, r),
    onSuccess: (r, t) => {
      const s = (i) => i?.filter((a) => a.objectId !== t.objectId);
      n.setQueryData(c.arealplaner.all, s), n.setQueriesData({ queryKey: c.arealplaner.searchAll }, s);
    },
    onSettled: (r, t, s) => {
      z(n), n.invalidateQueries({ queryKey: c.behandlinger.forPlan(s.nasjonalArealplanId) }), n.invalidateQueries({ queryKey: c.dokumenter.all }), n.invalidateQueries({ queryKey: c.aktorer.all });
    }
  });
}
function Ft() {
  const e = p();
  return I({
    queryKey: c.behandlinger.domains,
    queryFn: ({ signal: n }) => dr(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function Et(e) {
  const n = p();
  return I({
    queryKey: c.behandlinger.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => ur(n, e, { signal: r }),
    enabled: !!e
  });
}
function Dt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => cr(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function Tt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => pr(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function Bt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => fr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.behandlinger.forPlan(e) })
  });
}
function $t(e) {
  const n = p();
  return I({
    queryKey: c.dokumenter.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => gr(n, e, { signal: r }),
    enabled: !!e
  });
}
function St(e) {
  const n = p();
  return I({
    queryKey: c.dokumenter.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => yr(n, e, { signal: r }),
    enabled: !!e
  });
}
function Rt(e) {
  const n = p();
  return I({
    queryKey: c.dokumenter.forDispensasjon(e ?? ""),
    queryFn: ({ signal: r }) => hr(n, e, { signal: r }),
    enabled: !!e
  });
}
function Lt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => br(e, r.input, r.file),
    onSuccess: (r) => {
      r.nasjonalArealplanId && n.invalidateQueries({ queryKey: c.dokumenter.forPlan(r.nasjonalArealplanId) }), r.planbehUid && n.invalidateQueries({ queryKey: c.dokumenter.forBehandling(r.planbehUid) }), r.dispensasjonId && n.invalidateQueries({ queryKey: c.dokumenter.forDispensasjon(r.dispensasjonId) });
    }
  });
}
function Ot() {
  const e = p(), n = g();
  return y({
    /** `napId`: planen dokumentet vises under; brukes til sperresjekken når dokumentet mangler `nasjonalArealplanId`. */
    mutationFn: ({ dokument: r, napId: t }) => vr(e, r, t),
    onSuccess: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function Kt() {
  const e = p(), n = g();
  return y({
    mutationFn: ({ dokumenter: r, planbehUid: t, napId: s }) => kr(e, r, t, s),
    // Også ved feil: valget kan ha vært utdatert, så listene må hentes på nytt.
    onSettled: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function _t() {
  const e = p(), n = g();
  return y({
    mutationFn: ({ dokument: r, planbehUid: t }) => Ir(e, r, t),
    onSettled: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function Ct() {
  const e = p();
  return (n) => jr(e, n);
}
function Nt(e) {
  const n = p();
  return I({
    queryKey: c.aktorer.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => Pr(n, e, { signal: r }),
    enabled: !!e
  });
}
function qt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Fr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Ut(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Er(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function xt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Dr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Mt(e) {
  const n = p();
  return I({
    queryKey: c.planforhold.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Tr(n, e, { signal: r }),
    enabled: !!e
  });
}
function Jt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Br(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Qt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => $r(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Gt() {
  const e = p(), n = g();
  return y({
    mutationFn: ({ eksisterende: r, input: t }) => Sr(e, r, t),
    // Motpartens lister endres også (gammel og ny Til-plan).
    onSuccess: () => n.invalidateQueries({ queryKey: c.planforhold.all })
  });
}
function Vt() {
  const e = p(), n = g();
  return y({
    mutationFn: (r) => Rr(e, r),
    // Motpartens liste endres også.
    onSuccess: () => n.invalidateQueries({ queryKey: c.planforhold.all })
  });
}
function Ht(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Lr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Yt(e) {
  const n = p();
  return I({
    queryKey: c.dispensasjoner.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Or(n, e, { signal: r }),
    enabled: !!e
  });
}
function Wt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Kr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Zt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => _r(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function zt(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Cr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Xt(e) {
  const n = p();
  return I({
    queryKey: c.midlertidigeForbud.forKommune(e ?? ""),
    queryFn: ({ signal: r }) => Nr(n, e, { signal: r }),
    enabled: !!e
  });
}
function ea(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => qr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function na(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => Ur(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function ra(e) {
  const n = p(), r = g();
  return y({
    mutationFn: (t) => xr(n, t),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
const Jr = {
  plantype: [
    { code: "10", label: "Fylkesplan" },
    { code: "11", label: "Fylkesdelplan" },
    { code: "13", label: "Regional plan" },
    { code: "20", label: "Kommuneplan" },
    { code: "21", label: "Kommunedelplan" },
    { code: "34", label: "Områderegulering" },
    { code: "35", label: "Detaljregulering" },
    { code: "30", label: "Reguleringsplan (pbl 1985)" },
    { code: "31", label: "Bebyggelsesplan (pbl 1985)" }
  ],
  planstatus: [
    { code: "1", label: "Planlegging igangsatt" },
    { code: "2", label: "Planforslag" },
    { code: "3", label: "Endelig vedtatt" },
    { code: "4", label: "Opphevet" },
    { code: "5", label: "Utgått/erstattet" },
    { code: "6", label: "Vedtatt med utsatt rettsvirkning" },
    { code: "7", label: "Endelig vedtatt med tidsbegrensning" },
    { code: "8", label: "Overstyrt" }
  ],
  lovreferanse: [
    { code: "PBL2008", label: "Plan- og bygningsloven 2008" },
    { code: "PBL1985", label: "Plan- og bygningsloven 1985" },
    { code: "BL1965", label: "Bygningsloven 1965" }
  ],
  forslagsstillerType: [
    { code: "1", label: "Kommunen" },
    { code: "2", label: "Statlig myndighet" },
    { code: "3", label: "Fylkeskommune" },
    { code: "4", label: "Privat forslagsstiller" },
    { code: "9", label: "Annen" }
  ]
}, Qr = {
  planbehandlingtype: [
    { code: "A", label: "Testbehandling A" },
    { code: "B", label: "Testbehandling B" },
    { code: "C", label: "Testbehandling C" }
  ]
};
let Gr = 1;
const F = () => Gr++, D = () => `{${F().toString().padStart(8, "0")}-0000-0000-0000-000000000000}`;
class ta {
  constructor() {
    this.store = [];
  }
  findAll(n) {
    return Promise.resolve([...this.store]);
  }
  findByNapId(n, r) {
    return Promise.resolve(this.store.find((t) => t.nasjonalArealplanId === n) ?? null);
  }
  search(n, r) {
    const t = n.toLowerCase();
    return Promise.resolve(this.store.filter(
      (s) => s.plannavn?.toLowerCase().includes(t) || s.planId.includes(n) || s.nasjonalArealplanId.includes(n)
    ));
  }
  findPage(n, r, t) {
    const s = this.store.filter((a) => N(a, n)).sort((a, o) => De(a, o, n.sort)), i = s.slice(r.offset, r.offset + r.limit);
    return Promise.resolve({ items: i, hasMore: r.offset + i.length < s.length });
  }
  count(n, r) {
    return Promise.resolve(this.store.filter((t) => N(t, n)).length);
  }
  findByNapIds(n, r) {
    return Promise.resolve(this.store.filter((t) => n.includes(t.nasjonalArealplanId)));
  }
  getFacets(n) {
    const r = ["planstatus", "plantype", "lovreferanse", "admomrkode"], t = {};
    for (const s of r) {
      const i = /* @__PURE__ */ new Map();
      for (const a of this.store) {
        const o = a[s];
        o && i.set(o, (i.get(o) ?? 0) + 1);
      }
      t[s] = [...i.entries()].map(([a, o]) => ({ value: a, count: o })).sort((a, o) => a.value.localeCompare(o.value, "nb"));
    }
    return Promise.resolve(t);
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Arealplan ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(Jr);
  }
}
class aa {
  constructor() {
    this.store = [];
  }
  erSperret(n, r) {
    return Promise.resolve(this.store.some((t) => t.nasjonalArealplanId === n));
  }
  sperr(n) {
    return this.store.some((r) => r.nasjonalArealplanId === n.nasjonalArealplanId) ? Promise.resolve(!1) : (this.store.push(n), Promise.resolve(!0));
  }
}
class oa {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((t) => t.nasjonalArealplanId === n));
  }
  findByUid(n, r) {
    return Promise.resolve(this.store.find((t) => t.planbehUid === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planbehandling ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(Qr);
  }
}
class sa {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((t) => t.nasjonalArealplanId === n));
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((t) => t.planbehUid === n));
  }
  findForDispensasjon(n, r) {
    return Promise.resolve(this.store.filter((t) => t.dispensasjonId === n));
  }
  add(n, r) {
    const t = {
      ...n,
      objectId: F(),
      globalId: D(),
      ...r ? { filnavn: r.name, mimetype: r.type, referansedokumentfil: `fake://${r.name}` } : {}
    };
    return this.store.push(t), Promise.resolve(t);
  }
  settBehandling(n, r) {
    return this.store.forEach((t, s) => {
      n.includes(t.objectId) && (this.store[s] = { ...t, planbehUid: r ?? void 0 });
    }), Promise.resolve();
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  fetchAttachmentBlobUrl(n) {
    return Promise.resolve(`fake-blob://${n}`);
  }
}
class la {
  constructor() {
    this.store = [];
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((t) => t.planbehUid === n));
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Aktor ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class ia {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter(
      (t) => t.nasjonalArealplanIdFra === n || t.nasjonalArealplanIdTil === n
    ));
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planforhold ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class da {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((t) => t.nasjonalArealplanId === n));
  }
  findByDispensasjonId(n, r) {
    return Promise.resolve(this.store.find((t) => t.dispensasjonId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Dispensasjon ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class ua {
  constructor() {
    this.store = [];
  }
  findForKommune(n, r) {
    return Promise.resolve(this.store.filter((t) => t.kommunenummer === n));
  }
  findByForbudId(n, r) {
    return Promise.resolve(this.store.find((t) => t.forbudId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: F(), globalId: D() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((t) => t.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`MidlertidigForbud ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((t) => t.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
export {
  Mr as AREALPLAN_PAGE_SIZE,
  ge as AbortedError,
  Je as AuthError,
  Te as CODELIST_FIELDS,
  H as DEFAULT_AREALPLAN_SORT,
  ye as DEFAULT_PLANSTATUS,
  Hn as DISPENSASJONFRA_VALUES,
  Vn as DISPENSASJONSTYPE_VALUES,
  V as DOKUMENTTYPE_BESTEMMELSER,
  Jr as FAKE_AREALPLAN_DOMAINS,
  Qr as FAKE_PLANBEHANDLING_DOMAINS,
  Mn as FORSLAGSSTILLER_VALUES,
  la as FakeAktorRepository,
  aa as FakeArealplanIdSperrelisteRepository,
  ta as FakeArealplanRepository,
  da as FakeDispensasjonRepository,
  ua as FakeMidlertidigForbudRepository,
  oa as FakePlanbehandlingRepository,
  sa as FakePlandokumentRepository,
  ia as FakePlanforholdRepository,
  Ie as IKKE_GJELDENDE_PLANSTATUSER,
  xn as LOVREFERANSE_VALUES,
  b as NetworkError,
  v as NotFoundError,
  Be as PLANBEHANDLING_CODELIST_FIELDS,
  Re as PLANSTATUS_VALUES,
  Un as PLANTYPE_VALUES,
  pt as PlanregisterClientProvider,
  T as PlanregisterError,
  ke as VEDTATTE_PLANSTATUSER,
  w as ValidationError,
  wn as aktorFromAttrs,
  x as aktorInputToAttrs,
  st as aktorToAttrs,
  Oe as arealplanEndringSchema,
  X as arealplanFromAttrs,
  Le as arealplanInputSchema,
  q as arealplanInputToAttrs,
  at as arealplanToAttrs,
  ze as buildArealplanDomains,
  nn as buildArealplanOrderBy,
  re as buildArealplanWhere,
  $e as buildDomains,
  $ as buildInClause,
  pn as buildPlanbehandlingDomains,
  De as compareArealplaner,
  Xn as countArealplaner,
  Fr as createAktor,
  An as createArcgisAktorRepository,
  Sn as createArcgisArealplanIdSperrelisteRepository,
  un as createArcgisArealplanRepository,
  Tn as createArcgisDispensasjonRepository,
  $n as createArcgisMidlertidigForbudRepository,
  fn as createArcgisPlanbehandlingRepository,
  vn as createArcgisPlandokumentRepository,
  En as createArcgisPlanforholdRepository,
  rr as createArealplan,
  Kr as createDispensasjon,
  qr as createMidlertidigForbud,
  cr as createPlanbehandling,
  br as createPlandokument,
  Br as createPlanforhold,
  $r as createPlanforholdPar,
  lt as createPlanregisterClient,
  Dr as deleteAktor,
  lr as deleteArealplanMedTilhorende,
  Cr as deleteDispensasjon,
  xr as deleteMidlertidigForbud,
  fr as deletePlanbehandling,
  vr as deletePlandokument,
  Lr as deletePlanforhold,
  Rr as deletePlanforholdPar,
  he as deriveNasjonalArealplanId,
  Dn as dispensasjonFromAttrs,
  it as dispensasjonInputSchema,
  le as dispensasjonInputToAttrs,
  tt as domain,
  Ye as domainLabel,
  We as domainOptions,
  Qe as erIkkeGjeldende,
  ve as erSpeil,
  Q as erVedtatt,
  Xe as escapeSqlValue,
  jr as fetchPlandokumentAttachmentBlobUrl,
  Yn as findAllArealplaner,
  Wn as findArealplanByNapId,
  zn as findArealplanPage,
  er as findArealplanerByNapIds,
  dt as findBehandlingByUid,
  ut as findDispensasjonById,
  ct as findMidlertidigForbudById,
  He as finnErstattendePlaner,
  Pe as finnFrakoblingBlokkering,
  be as finnIdBlokkering,
  Fe as finnKoblingBlokkering,
  je as finnSlettBlokkering,
  Ir as frakobleDokumentFraBehandling,
  Ee as kanFjernesFraBehandling,
  kr as knyttDokumenterTilBehandling,
  Pr as loadAktorerForBehandling,
  tr as loadArealplanDomains,
  nr as loadArealplanFacets,
  ur as loadBehandlingerForPlan,
  Or as loadDispensasjonerForPlan,
  yr as loadDokumenterForBehandling,
  hr as loadDokumenterForDispensasjon,
  gr as loadDokumenterForPlan,
  Nr as loadMidlertidigForbudForKommune,
  dr as loadPlanbehandlingDomains,
  Tr as loadPlanforholdForPlan,
  _e as loadSlettegrunnlag,
  N as matchesArealplanQuery,
  Bn as midlertidigForbudFromAttrs,
  de as midlertidigForbudInputToAttrs,
  G as motsattForholdtype,
  M as normalizeAdmomrkode,
  cn as planbehandlingFromAttrs,
  Qn as planbehandlingInputSchema,
  U as planbehandlingInputToAttrs,
  ot as planbehandlingToAttrs,
  gn as plandokumentFromAttrs,
  Gn as plandokumentInputSchema,
  yn as plandokumentInputToAttrs,
  Fn as planforholdFromAttrs,
  oe as planforholdInputToAttrs,
  Ae as planforholdSettFra,
  c as planregisterKeys,
  sn as queryCount,
  W as queryFeaturesPaged,
  ln as queryGroupCounts,
  on as queryTablePage,
  B as queryTablePaged,
  k as qv,
  Zn as searchArealplaner,
  we as speilAv,
  Er as updateAktor,
  sr as updateArealplan,
  _r as updateDispensasjon,
  Ur as updateMidlertidigForbud,
  pr as updatePlanbehandling,
  Sr as updatePlanforholdPar,
  Nt as useAktorer,
  It as useArealplan,
  ht as useArealplanCount,
  jt as useArealplanDomains,
  kt as useArealplanFacets,
  yt as useArealplanPages,
  At as useArealplanSlettegrunnlag,
  mt as useArealplaner,
  bt as useArealplanerByNapIds,
  gt as useArealplanerSearch,
  qt as useCreateAktor,
  vt as useCreateArealplan,
  Wt as useCreateDispensasjon,
  ea as useCreateMidlertidigForbud,
  Dt as useCreatePlanbehandling,
  Lt as useCreatePlandokument,
  Jt as useCreatePlanforhold,
  Qt as useCreatePlanforholdPar,
  xt as useDeleteAktor,
  Pt as useDeleteArealplanMedTilhorende,
  zt as useDeleteDispensasjon,
  ra as useDeleteMidlertidigForbud,
  Bt as useDeletePlanbehandling,
  Ot as useDeletePlandokument,
  Ht as useDeletePlanforhold,
  Vt as useDeletePlanforholdPar,
  Yt as useDispensasjoner,
  Ct as useFetchPlandokumentAttachmentUrl,
  _t as useFrakoblePlandokumentFraBehandling,
  Kt as useKnyttPlandokumenterTilBehandling,
  Xt as useMidlertidigeForbud,
  Ft as usePlanbehandlingDomains,
  Et as usePlanbehandlinger,
  St as usePlandokumenterForBehandling,
  Rt as usePlandokumenterForDispensasjon,
  $t as usePlandokumenterForPlan,
  Mt as usePlanforhold,
  p as usePlanregisterClient,
  ft as usePlanregisterClientOptional,
  Ut as useUpdateAktor,
  wt as useUpdateArealplan,
  Zt as useUpdateDispensasjon,
  na as useUpdateMidlertidigForbud,
  Tt as useUpdatePlanbehandling,
  Gt as useUpdatePlanforholdPar,
  J as utledSaksnummerdeler
};
//# sourceMappingURL=index.mjs.map
